import "./App.css";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { ThemeContextProvider } from "./utils/ThemeContext";

// Stores
import { userStore } from "./stores/sharedStores";
import { getAccessToken, persistSession } from "./api/AuthSession";

// Layouts
import DefaultLayout from "./projects/swageazy/views/layout/DefaultLayout";
import SwayyLayout from "./projects/swayy/layout/SwayyLayout";
import { useActiveWorkspace } from "./utils/WorkspaceContext";

// Pages
import Login from "./views/pages/Login";
import { NotificationProvider } from "./utils/NotificationsContext";
import ForgetPassword from "./views/pages/ForgetPassword";
import ResetPasswordOtp from "./views/pages/ResetPasswordOtp";
import usePageTracking from "./analytics/pageTracking";
import GoogleSuccessPopup from "./views/pages/GoogleSuccessPopup";
import NetworkStatusBanner from "./views/components/common/NetworkStatusBanner";

function App() {
  usePageTracking();

  const [loading, setLoading] = useState(true);
  const activeWorkspace = useActiveWorkspace();

  const [searchParams] = useSearchParams();
  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      persistSession({ token });
    }

    const storedToken = getAccessToken();
    if (!storedToken) {
      setLoading(false);
      return;
    }

    userStore
      .getUserDetails(activeWorkspace)
      .catch((_err) => console.log("LOGGED OUT"))
      .finally(() => setLoading(false));
  }, [userStore, activeWorkspace, searchParams.get("token")]);

  return (
    <ThemeContextProvider>
      <NotificationProvider>
        <NetworkStatusBanner />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Routes>
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route
              path="/change-password"
              element={<ResetPasswordOtp />}
            />
            <Route path="/google-auth/success" element={<GoogleSuccessPopup />} />
            {userStore.isLoggedIn ? (
              <>
                <Route
                  path="*"
                  element={
                    activeWorkspace === "swayy" ? (
                      <SwayyLayout />
                    ) : (
                      <DefaultLayout />
                    )
                  }
                />
              </>
            ) : (
              <>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </>
            )}
          </Routes>
        )}
      </NotificationProvider>
    </ThemeContextProvider>
  );
}

export default observer(App);